export default __webpack_public_path__ + "static/media/timer.eb546df9.svg";